import { useLocation } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaMapMarkerAlt, FaBed, FaMoon } from "react-icons/fa";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";



const ResortInfo = () => {
  const location = useLocation();
  const resort = location.state?.resort;

  if (!resort) return <div>No Resort Data</div>;
  
const [loading, setLoading] = useState(false);
const [message, setMessage] = useState("");

const navigate = useNavigate();

const handleAvailabilitySubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setMessage("");

  const formData = new FormData(e.target);

  // 🔐 Web3Forms Access Key
  formData.append("access_key", "ac2e9cee-6cba-4036-ba57-56c081ef5ea8");

  // 📌 Email Subject
  formData.append("subject", "New Room Availability Inquiry 🏨");

  // 📌 From Name
  formData.append("from_name", "Wedding Stays Website");

  // 📌 Resort Info
  formData.append("Resort Name",resort.name);
  formData.append("Resort Price", `₹ ${resort.price}`);

  try {
    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (data.success) {
      setMessage("You will be notified shortly ✅");
      e.target.reset();
    } else {
      setMessage("Something went wrong ❌");
    }
  } catch (error) {
    setMessage("Submission failed ❌");
  }

  setLoading(false);
};



  return (
    <section className="bg-[#fdf7f7] min-h-screen py-16 px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-10">
        {/* LEFT CONTENT */}
        <div className="md:col-span-2 bg-white p-4 rounded-2xl shadow-md">
          {/* Main Image */}
          <a href={resort.image}>
            <img
              src={resort.image}
              alt={resort.name}
              className="w-full h-[400px] object-cover rounded-xl mb-4"
            />
          </a>
          {/* Gallery Images */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            {resort.gallery?.map((img, index) => (
              <a href={img}>
                <img
                  key={index}
                  src={img}
                  alt={`Gallery ${index}`}
                  className="h-[120px] w-full object-cover rounded-lg cursor-pointer hover:scale-105 transition duration-300"
                />
              </a>
            ))}
          </div>

          <h1 className="md:text-3xl text-xl font-serif mb-6">{resort.name}</h1>
          <div className="flex items-start gap-2">
            <FaMapMarkerAlt className="text-gray-400" />
            {resort.location}
          </div>

          <button
            onClick={() =>
              navigate("/resort/:id/packages", { state: { resort } })
            }
            className="mt-6 font-serif text-sm bg-[#b76d68] text-white px-6 py-3 rounded-lg hover:bg-rose-700 transition"
          >
            View Packages
          </button>
          {/* Description */}
          <h2 className="text-2xl font-serif mt-8 mb-4">Description</h2>
          <p className="text-gray-600 font-serif">{resort.description}</p>

          <div className="flex items-start gap-2">
            <h1 className="text-2xl font-serif mt-6 mb-4">
              Guests: {resort.guests}
            </h1>
          </div>

          <div className="flex items-start gap-2">
            <h1 className="text-2xl font-serif mt-6 mb-4">
              Nights: {resort.nights}
            </h1>
          </div>

          {/* Facilities */}
          <h2 className="text-2xl font-serif mt-8 mb-4">Hotel Facilities</h2>
          <ul className="space-y-2">
            {resort.facilities?.map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-2 font-serif text-gray-600"
              >
                <FaCheckCircle className="text-red-500 shrink-0 mt-1" />
                {item}
              </li>
            ))}
          </ul>

          {/* Menu */}
          <h2 className="text-2xl font-serif mt-8 mb-4">Menu</h2>
          <ul>
            {resort.menu?.map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-2 font-serif text-gray-600"
              >
                <FaCheckCircle className="text-red-500 shrink-0 mt-1" />
                {item}
              </li>
            ))}
          </ul>

          {/* Room Rates */}
          <h2 className="text-2xl font-serif mt-8 mb-4">Room Rate</h2>
          <ul>
            {resort.roomRates?.map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-2 font-serif text-gray-600"
              >
                <FaCheckCircle className="text-red-500 shrink-0 mt-1  " />
                <span>{item}</span>
              </li>
            ))}
          </ul>

          {/* Inclusions */}
          <h2 className="text-2xl font-serif mt-8 mb-4">
            Room Rate Inclusions
          </h2>
          <ul>
            {resort.inclusions?.map((item, i) => (
              <li
                key={i}
                className="flex items-start gap-2 font-serif text-gray-600"
              >
                <FaCheckCircle className="text-red-500 shrink-0 mt-1" />
                {item}
              </li>
            ))}
          </ul>

          {/* Wedding Budget */}
          <h2 className="text-2xl font-serif mt-8 mb-4">
            Wedding Planning & Decoration Budget
          </h2>
          <p className="text-gray-600">{resort.weddingBudget}</p>
        </div>

        {/* RIGHT SIDE PANEL */}
        <div className="bg-white p-6 rounded-2xl shadow-md h-fit sticky top-20">
          <h3 className="text-xl font-semibold mb-4">Budget</h3>

          <div className="text-2xl text-red-500 shrink-0 mt-1 font-bold mb-4">
            ₹ {resort.price}
          </div>

          <div className="mt-6">
            <h4 className="font-semibold mb-2">Check Availability</h4>

            <form onSubmit={handleAvailabilitySubmit}>
              {/* User Info */}
              <input
                type="text"
                name="Full Name"
                placeholder="Your Name"
                required
                className="w-full border rounded-md p-2 mb-3"
              />

              <input
                type="email"
                name="email"
                placeholder="Your Email"
                required
                className="w-full border rounded-md p-2 mb-3"
              />

              <input
                type="tel"
                name="Phone"
                placeholder="Your Phone"
                required
                className="w-full border rounded-md p-2 mb-3"
              />
              <input
                type="number"
                name="Number of Guests"
                placeholder="Guests"
                required
                className="w-full border rounded-md p-2 mb-4"
              />
              {/* Booking Info */}
              <input
                type="date"
                name="Check In Date"
                required
                className="w-full border rounded-md p-2 mb-3"
              />

              <input
                type="date"
                name="Check Out Date"
                required
                className="w-full border rounded-md p-2 mb-3"
              />

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-gray-800 text-white py-3 rounded-md hover:bg-black transition disabled:opacity-60"
              >
                {loading ? "Checking..." : "Check Availability"}
              </button>

              {message && (
                <p className="mt-4 text-green-600 text-sm text-center">
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResortInfo;
